



import { i18n } from '@/i18n';
import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * 无更多数据
 */
@Component
export default class WeCouponsNoMoreTips extends Vue {
  /**
   * 是否有下一步优惠
   */
  @Prop({ default: true }) hasNext!: boolean;

  /**
   * 提示信息
   */
  get tips() {
    return this.hasNext ? i18n('繼續上滑查看更多優惠') : i18n('更多優惠敬請期待');
  }
}

